<template>
  <div class="home">
    <div class="top-image">
      <img alt="top image" src="@/assets/top/top-image.png" :style="{width : topImageSize[0], height : topImageSize[1], 'margin-left' : topImageSize[2], 'margin-top' : topImageSize[3]}">
      <!-- <video id="hero-video" src="@/assets/estate_icon/top-video.mp4" preload="auto" loop="" autoplay="" muted="" :style="{width : topVideoSize[0], height : topVideoSize[1], 'margin-left' : topVideoSize[2], 'margin-top' : topVideoSize[3]}"></video> -->
      <div class="top-logo">
        <h1>ESTATE ONE</h1>
        <br>
        <h3> 不動産を通じて日本から世界へ </h3>
      </div>
    </div>
    <!-- <news msg="news field"/> -->
    <contents msg="content field"/>
    <contact msg="contact us"/>
  </div>
</template>

<script>
// @ is an alias to /src
// import news from '@/components/home/news.vue'
import contents from '@/components/home/contents.vue'
import contact from '@/components/home/contact.vue'

export default {
  name: 'home',
  components: {
    // news,
    contents,
    contact
  },
  data: function () {
    this.w_width = window.innerWidth
    this.w_height = window.innerHeight
    this.rate = 1.33105
    this.result = this.computeResize(this.w_width, this.w_height, this.rate)
    this.rate = 1.777
    this.video_result = this.computeResize(this.w_width, this.w_height, this.rate)

    return {
      w_width: window.innerWidth,
      w_height: window.innerHeight,
      topImageSize: this.result,
      topVideoSize: this.video_result
    }
  },
  methods: {
    handleResize: function () {
      this.w_width = window.innerWidth
      this.w_height = window.innerHeight
      this.rate = 1.33105
      this.topImageSize = this.computeResize(this.w_width, this.w_height, this.rate)
      this.rate = 1.777
      this.topVideoSize = this.computeResize(this.w_width, this.w_height, this.rate)
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss">
  @import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);

  .home{
    overflow: hidden;
  }
  .top-image{
    overflow: hidden;
    width: 100vw;
    height: 100vh;

    text-align: center;

    @media (max-width: 550px) {
      img{
        display: block;
        margin-top: 0px;
        text-align: center;
      }
    }
  }
  #hero-video{
    display: block;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    //position: fixed;
    z-index: 0;

    text-align: center;

    @media (max-width: 550px) {
      display: none;
    }
  }
  .top-logo{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content:center;
    overflow: hidden;

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    z-index: 5;

    img {
      display: inline-block;
      max-width: 26vw;
      height: auto;
    }
    h1 {
      font-family: Noto Sans Japanese, Bold;
      display: inline-block;
      font-size: 3vw;
      //max-width: 30vw;
      color: #fff;
      text-shadow: 0px 0px 20px #000000;
      letter-spacing: 20px;
      @media(max-width: 550px){
        letter-spacing: 5px;
      }
    }
    h3 {
      font-family: Noto Sans Japanese, Bold;
      display: inline-block;
      font-size: 1.2vw;
      margin-top: 1.7vw;
      margin-left: 3.8vw;
      color: #fff;
      text-shadow: 0px 0px 20px #000000;
    }

    @media (max-width: 550px) {
      flex-direction: column;

      img{
        max-width: 65vw;
        margin: 0;
        margin-left: 0;
      }
      h1{
        max-width: 65vw;
        font-size: 7.6vw;
      }
      h3{
        font-size: 3.2vw;
        margin: 0;
      }
    }
  }
</style>
